import { createSelector } from '@ngrx/store';

import { MaintenancePeriod } from '../../../admin/components/maintenance-period/model/maintenance-period';
import { getMaintenancePeriodState } from '../reducers/maintenancePeriod';

export const getCurrentMaintenancePeriod = createSelector(
    getMaintenancePeriodState,
    (state: MaintenancePeriod) => state,
);
